"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.page.title': 'Chat',
};
